import React, { useState, useEffect, useRef } from "react";
import styles from "./InstagramResize.module.css";

const InstagramResize = () => {

    const [showToast, setShowToast] = useState(false);
    const [fileName, setFileName] = useState("");
    const [downloadSuccess, setDownloadSuccess] = useState(false);

    useEffect(() => {
        document.title = "Redimensionar Imagem para Instagram (Feed, Story e Reels) | Fohattech";
    }, []);

    const [image, setImage] = useState(null);
    const [format, setFormat] = useState("square");
    const canvasRef = useRef(null);

    const formats = {
        square: { width: 1080, height: 1080 },
        story: { width: 1080, height: 1920 },
        portrait: { width: 1080, height: 1350 },
    };

    function handleImageUpload(e) {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);

            const reader = new FileReader();
            reader.onload = () => setImage(reader.result);
            reader.readAsDataURL(file);
        }
    }

    function processImage() {
        if (!image) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        const img = new Image();
        img.src = image;

        img.onload = () => {
            const { width, height } = formats[format];

            canvas.width = width;
            canvas.height = height;

            ctx.fillStyle = "#222";
            ctx.fillRect(0, 0, width, height);

            const ratio = Math.min(width / img.width, height / img.height);

            const newWidth = img.width * ratio;
            const newHeight = img.height * ratio;

            const x = (width - newWidth) / 2;
            const y = (height - newHeight) / 2;

            ctx.drawImage(img, x, y, newWidth, newHeight);
        };
    }

    function downloadImage() {
        const canvas = canvasRef.current;
        const link = document.createElement("a");
        link.download = "instagram-image.jpg";
        link.href = canvas.toDataURL("image/jpeg");
        link.click();

        setDownloadSuccess(true);
        setTimeout(() => {
            setDownloadSuccess(false);
        }, 2000);
    }

    async function handleShare() {
        try {
            if (navigator.share) {
                await navigator.share({
                    title: "Redimensionar Imagem para Instagram",
                    text: "Ferramenta grátis para ajustar imagens para Instagram!",
                    url: window.location.href,
                });
            } else {
                fallbackShare();
            }
        } catch (error) {
            console.log("Compartilhamento cancelado ou não suportado");
        }
    }

    function fallbackShare() {
        const url = window.location.href;

        navigator.clipboard.writeText(url);

        setShowToast(true);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    }

    return (
        <div className={styles.container}>

            <h2 className={styles.title}>Redimensionar Imagem para Instagram</h2>
            <p className={styles.subtitle}>
                Ajuste suas imagens automaticamente para os formatos ideais do Instagram como feed, story e reels.
            </p>

            {/* SEO FORTE */}
            <div className={styles.infoBox}>
                <p>
                    Esta ferramenta foi criada para facilitar o redimensionamento de imagens para os formatos mais utilizados no Instagram, incluindo feed quadrado (1:1), feed vertical (4:5) e stories ou reels (9:16). Com ela, você pode preparar suas imagens de forma rápida, prática e totalmente online, sem precisar instalar programas ou utilizar aplicativos pesados.
                    <br /><br />
                    O sistema funciona diretamente no navegador, garantindo mais segurança e privacidade, já que nenhuma imagem é enviada para servidores externos. Todo o processamento acontece localmente no seu dispositivo, o que também torna a ferramenta extremamente rápida e eficiente.
                    <br /><br />
                    Ideal para criadores de conteúdo, social media, designers e qualquer pessoa que deseja manter um padrão profissional no Instagram. Ao utilizar os tamanhos corretos, suas imagens ficam mais bem posicionadas no feed, evitam cortes indesejados e aumentam o impacto visual das suas postagens.
                    <br /><br />
                    Basta adicionar uma imagem, escolher o formato desejado e clicar em redimensionar. Em poucos segundos, você terá sua imagem pronta para download e uso imediato.
                </p>
            </div>

            <div className={styles.toolBox}>

                <div className={`${styles.uploadBox} ${image ? styles.uploadActive : ""}`}>

                    <label className={styles.uploadLabel}>
                        📁 Adicionar Imagem
                        <input
                            type="file"
                            onChange={handleImageUpload}
                            className={styles.hiddenInput}
                        />
                    </label>

                    {image && (
                        <div className={styles.fileInfo}>
                            <span className={styles.fileName}>{fileName}</span>
                            <span className={styles.fileSuccess}>✔</span>
                        </div>
                    )}

                </div>

                <select
                    value={format}
                    onChange={(e) => setFormat(e.target.value)}
                    className={styles.select}
                >
                    <option value="square">Feed (1:1)</option>
                    <option value="portrait">Feed Vertical (4:5)</option>
                    <option value="story">Story / Reels (9:16)</option>
                </select>

                <button onClick={processImage} className={styles.button}>
                    Redimensionar
                </button>

            </div>

            <div className={styles.resultBox}>
                <canvas ref={canvasRef} className={styles.canvas}></canvas>

                <button
                    onClick={downloadImage}
                    className={`${styles.buttonDownload} ${downloadSuccess ? styles.downloadSuccess : ""}`}
                >
                    {downloadSuccess ? "✔ Baixado com sucesso!" : "Baixar Imagem"}
                </button>

                <button onClick={handleShare} className={styles.buttonShare}>
                    Compartilhar esta ferramenta 🔗
                </button>
            </div>

            {/* CONTEÚDO EXTRA (SEO FORTE) */}
            <div className={styles.extraContent}>
                <h3>Como funciona o redimensionamento de imagens?</h3>
                <p>
                    O redimensionamento é feito utilizando a tecnologia de canvas do navegador, que permite ajustar a imagem proporcionalmente sem distorcer sua qualidade. A imagem original é analisada e redimensionada automaticamente para se encaixar no formato escolhido, mantendo o máximo possível da nitidez.
                    <br /><br />
                    Além disso, a ferramenta adiciona um fundo adaptado quando necessário, evitando cortes bruscos e garantindo que toda a imagem seja preservada dentro das dimensões exigidas pelo Instagram.
                    <br /><br />
                    Utilizar imagens no tamanho correto é essencial para melhorar o alcance e a apresentação do seu conteúdo. O Instagram prioriza conteúdos bem formatados, e imagens ajustadas corretamente tendem a gerar mais engajamento, cliques e interações.
                </p>
            </div>

            <div id="BoxAfiliados" className={styles.afiliados}></div>

            {showToast && (
                <div className={styles.toast}>
                    🔗 Link copiado com sucesso!
                </div>
            )}
        </div>
    );
};

export default InstagramResize;